import { TooltipProps } from "recharts";
import {
  NameType,
  ValueType
} from "recharts/types/component/DefaultTooltipContent";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import { formatLastDayOfMonth, simpleDate, toLocalDate } from "@/utils/datetime";
import { useArrMrr } from "@/services/context/ArrMrrContext";
import { formatPipelineValue } from "../helpers";
import { TransformedChartData } from "@/components/layouts/PipelineOverTime/types";

const CustomTooltip = ({
  active,
  payload
}: TooltipProps<ValueType, NameType>) => {
  const { t } = useTranslation();

  const { label: arrMrrLabel } = useArrMrr();

  if (!active || !payload || !payload.length) return null;

  const data = payload[0].payload as TransformedChartData;
  const totalDeals = data.actualDeals + data.forecastedDeals;
  const totalMRR = data.actualPipeline + data.forecastedPipeline;

  const formattedDate = data.periodEndDate
    ? simpleDate(toLocalDate(data.periodEndDate), "short", false, true)
    : formatLastDayOfMonth(data.month, data.year);

  const isForecast = data.forecastedPipeline > 0 || data.forecastedDeals > 0;

  return (
    <div className="relative z-50 overflow-hidden rounded-md border-0 bg-surface-tooltip-toast px-4 py-2 shadow-md">
      <div className="w-full flex flex-col gap-2">
        <Text variant="smBodySecondary">
          {`${t(`pipelineOverTime.${isForecast ? "expectedTooltip" : "tooltip"}`)} ${formattedDate}`}
        </Text>
        <div className="flex flex-col gap-1">
          <div className="flex items-center justify-between gap-8">
            <Text>{totalDeals}</Text>
            <Text variant="bodySecondary">{t("pipelineOverTime.deals")}</Text>
          </div>
          <div className="flex items-center justify-between gap-8">
            <Text>{formatPipelineValue(totalMRR)}</Text>
            <Text variant="bodySecondary">
              {t("pipelineOverTime.totalArrMrr", { arrMrr: arrMrrLabel })}
            </Text>
          </div>
        </div>
      </div>
      <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-surface-tooltip-toast"></div>
    </div>
  );
};

export default CustomTooltip;
